import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as WarningRed } from 'assets/icons/red-alert.svg';
import { Modal, TextAreaField } from 'components';

const ReturnToCoeModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  outcome,
  businessKey
}) => {
  const user = useSelector(state => state.user);
  const [returnMessage, setReturnMessage] = useState("");

  const renderContent = () => {
    return (
        <div>
        <WarningRed></WarningRed>
        <div className="content-title-2 font-size-18 mb-2">
            Επιστροφή στο CoE
        </div>
            Πρόκειται να επιστρέψετε την Αίτηση με αριθμό {businessKey}.
            Παρακαλούμε επιβεβαιώστε την ενέργεια εισάγοντας ταυτόχρονα την αιτιολογία επιστροφής.
            Διαφορετικά, επιλέξτε Ακύρωση.
              
            <div className="mt-2">
                    <TextAreaField
                      label={<div className='content-title-3 .font-size-16'>Αιτιολογία Επιστροφής  <span className='color-red'>*</span></div>}
                      placeholder={'Αιτιολογία Επιστροφής'}
                      value={returnMessage}
                      maxLength={500}
                      onChange={event =>
                        setReturnMessage(event.target.value)
                      }
                    />
            </div>
        </div>
    );
  };

  const submit = () => {
    setIsVisible(false);
    handleSubmit(returnMessage);
    setReturnMessage("");
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        setVisible={setIsVisible}
        handleCancel={() => {
          setIsVisible(false);
          setReturnMessage("");
        }}        
        handleConfirm={submit}
        cancelText={'Ακύρωση'}
        okText={'Eπιστροφή'}
        Icon={WarningRed }
        outcome={outcome}
        user={user}
        submitDisabled={!returnMessage || returnMessage === ""}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
    </>
  );
};

export default ReturnToCoeModal;
